/*
 * File: feed.slice.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on April 2, 2025 at 9:17 AM
 * Copyright © 2025 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: June 10, 2025 at 11:30 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import { createSlice } from '@reduxjs/toolkit';

// Constants
import {
	FEED_ACTION_CURATED, MESSAGE_FEED_FILTER_MESSAGE_TYPE, STORY_FEED_FILTER_MEDIUM
} from '../../../../constants/feed.constants';


/**
 * Constants
 */

export const initialState = {

	// Feed - All
	feedAllStatus: 'idle',
	feedAllError: null,
	feedAllItems: [],
	feedAllActionSortBy: FEED_ACTION_CURATED,
	feedAllActionFilterMedium: STORY_FEED_FILTER_MEDIUM,
	feedAllSelectedTags: [],

	// Feed - Messages
	feedMessagesStatus: 'idle',
	feedMessagesError: null,
	feedMessagesItems: [],
	feedMessagesActionSortBy: FEED_ACTION_CURATED,
	feedMessagesActionFilterMessageType: MESSAGE_FEED_FILTER_MESSAGE_TYPE,

	// Feed - Stories
	feedStoriesStatus: 'idle',
	feedStoriesError: null,
	feedStoriesItems: [],
	feedStoriesActionSortBy: FEED_ACTION_CURATED,
	feedStoriesActionFilterMedium: STORY_FEED_FILTER_MEDIUM,
	feedStoriesSelectedTags: [],
};


/**
 * Slices
 */

export const feedSlice = createSlice({
	name: 'feed',
	initialState,
	reducers: {
		updateAllFeed: (state, action) => {

			// Set state
			state.feedAllItems = action.payload;
			state.feedAllStatus = 'final';
		},
		updateMessagesFeed: (state, action) => {

			// Set state
			state.feedMessagesItems = action.payload;
			state.feedMessagesStatus = 'final';
		},
		updateStoriesFeed: (state, action) => {

			// Set state
			state.feedStoriesItems = action.payload;
			state.feedStoriesStatus = 'final';
		},
		updateAllFeedActionSortBy: (state, action) => {

			// Set state
			state.feedAllActionSortBy = action.payload;
		},
		updateAllFeedActionFilterMedium: (state, action) => {

			// Set state
			state.feedAllActionFilterMedium = action.payload;
		},
		updateAllFeedSelectedTags: (state, action) => {

			// Set state
			state.feedAllSelectedTags = action.payload;
		},
		updateMessagesFeedActionSortBy: (state, action) => {

			// Set state
			state.feedMessagesActionSortBy = action.payload;
		},
		updateMessagesFeedActionFilterMessageType: (state, action) => {

			// Set state
			state.feedMessagesActionFilterMessageType = action.payload;
		},
		updateStoriesFeedActionSortBy: (state, action) => {

			// Set state
			state.feedStoriesActionSortBy = action.payload;
		},
		updateStoriesFeedActionFilterMedium: (state, action) => {

			// Set state
			state.feedStoriesActionFilterMedium = action.payload;
		},
		updateStoriesFeedSelectedTags: (state, action) => {

			// Set state
			state.feedStoriesSelectedTags = action.payload;
		},
		clearAllFeed: (state) => {

			// Clear state
			state.feedAllItems = [];
			state.feedAllStatus = 'idle';
		},
		clearMessagesFeed: (state) => {

			// Clear state
			state.feedMessagesItems = [];
			state.feedMessagesStatus = 'idle';
		},
		clearStoriesFeed: (state) => {

			// Clear state
			state.feedStoriesItems = [];
			state.feedStoriesStatus = 'idle';
		},
	},
	extraReducers: {},
});


/**
 * Exports
 */

export const {
	updateAllFeed,
	updateMessagesFeed,
	updateStoriesFeed,
	updateAllFeedActionSortBy,
	updateAllFeedActionFilterMedium,
	updateAllFeedSelectedTags,
	updateMessagesFeedActionSortBy,
	updateMessagesFeedActionFilterMessageType,
	updateStoriesFeedActionSortBy,
	updateStoriesFeedActionFilterMedium,
	updateStoriesFeedSelectedTags,
	clearAllFeed,
	clearMessagesFeed,
	clearStoriesFeed
} = feedSlice.actions;

export default feedSlice.reducer;
